import { ROLE_ADMIN } from '@/enum/roles'
import routeType from '@/router/routeType'

const meta = {
    requiresAuth: true,
    roles: [ROLE_ADMIN],
    layout: 'ordit-authenticated-layout',
}

const breadCrumbs = {
    registrationCodesList: {
        to: {
            name: routeType.REGISTRATION_CODES_LIST,
        },
        label: 'menu.registration_codes',
        roles: [ROLE_ADMIN],
    },
}

const passthroughRender = {
    render: (c) => c('router-view'),
}

export default [
    {
        path: '/registration-codes',
        component: passthroughRender,
        meta,
        children: [
            {
                path: '',
                name: routeType.REGISTRATION_CODES_LIST,
                component: () =>
                    import(
                        /* webpackChunkName: "registration-codes-list" */ '@/pages/registrationCodes/List.vue'
                    ),
                meta,
            },
            {
                path: 'create',
                name: routeType.REGISTRATION_CODES_CREATE,
                component: () =>
                    import(
                        /* webpackChunkName: "registration-codes-edit" */ '@/pages/registrationCodes/Create.vue'
                    ),
                meta: {
                    ...meta,
                    breadcrumbs: [breadCrumbs.registrationCodesList],
                },
            },
            {
                path: ':id',
                name: routeType.REGISTRATION_CODES_EDIT,
                component: () =>
                    import(
                        /* webpackChunkName: "registration-codes-edit" */ '@/pages/registrationCodes/Edit.vue'
                    ),
                meta: {
                    ...meta,
                    breadcrumbs: [breadCrumbs.registrationCodesList],
                },
            },
        ],
    },
]
